<template>
    <div class="wizard-payment-registration">
        <div class="text-center my-12">
            <h3>{{$trans.get('wizard.step4.title')}}</h3>
        </div>
        <div class="grid-payment-registration mb-12">
            <div class="column-payment lg:pr-12">
                <h6 class="mb-6">{{$trans.get('wizard.step4.text1')}}</h6>
                <card-courses>
                    <h3 class="mb-3"><span class="uppercase">{{getSelectedCourse.type}}</span> - {{getSelectedCourse.name[$store.state.locale]}}</h3>
                    <p>{{$trans.get('wizard.step4.pay-method')}} {{modpayment()}}</p>
                    <hr class="my-3">
                    <div class="flex justify-between">
                        <p class="text-blue">{{$trans.get('wizard.step4.price')}}</p>
                        <p class="text-blue">€ {{price()}}</p>
                    </div>
                </card-courses>
            </div>
            <div class="column-payment lg:pl-12 mt-6 lg:mt-0">
                <h6>{{$trans.get('wizard.step4.title2')}}</h6>
                <div>
                    <payment-selector @pay="paymentMethod"></payment-selector>
                    <form
                        id="matriculationForm"
                        name="frm"
                        class="flex"
                        :action="redsysUrl"
                        method="POST"
                    >
                        <input type="hidden" name="Ds_SignatureVersion" v-model="version" />
                        <input type="hidden" name="Ds_MerchantParameters" v-model="params" />
                        <input type="hidden" name="Ds_Signature" v-model="signature" />
                    </form>
                    <div class="px-8 mt-3">
                     <button @click="handlePaymentClick()" class="btn btn-primary w-full">{{$trans.get('wizard.step4.button')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import PaymentSelector from '../components/PaymentSelector';
import { mapGetters, mapMutations } from "vuex";
import axios from 'axios';
export default {
    data() {
        return {
            params: "",
            signature: "",
            version: "",
        }
    },
    components:{
        PaymentSelector
    },
    methods: {
        ...mapMutations({
            setRegistration: 'setRegistration'
        }),
        price(){
            if(this.getSelecteds.course.type === 'other'){
                return this.getSelecteds.course.total_price;
            }else{
                return 250;
            }
        },
        paymentMethod: (value) => {
            return value;
        },
        handlePaymentClick(){
            switch (this.getSelecteds.paymentmethod) {
                case 'transfer':
                    this.sendDataTransfer()
                    break;
                case 'card':
                    this.sendDataRedsys()
                    break;
                default:
                    this.$toast.error('Error, no se puede continuar');
                    break;
            }
        },
        sendDataRedsys(){
            axios.post('/'+window.appLocale+'/api/save-data/redsys', {
                    payload: JSON.stringify({ ...this.getSelecteds, locale: window.appLocale }),
                    }).then((res) => {
                        this.params = res.data["params"];
                        this.signature = res.data["signature"];
                        this.version = res.data["version"];
                    }).then((res) => {
                        document.getElementById("matriculationForm").submit();
                    }).catch(() => {
                        this.$toast.error(this.$trans.get('wizard.error-msg'));
                    })
        },
        sendDataTransfer(){
            axios.post('/'+window.appLocale+'/api/save-data/transfer', {
                payload: JSON.stringify({ ...this.getSelecteds, locale: window.appLocale }),
            }).then((res) => {
                this.setRegistration(res.data)
                this.$router.push({ name: 'confirmacion-preinscripcion' });
            }).catch(() => {
                this.$toast.error(this.$trans.get('wizard.error-msg'));
            })
        },
        modpayment(){
            switch (this.$store.state.selected.dues) {
                case 'year':
                    return this.$trans.get('wizard.step4.full-course');
                case 'month':
                    return this.$trans.get('wizard.step4.mon-payment');
                default:
                    return 'undefined';
            }
        },
        goToConfirmation() {
        this.$router.push({ name: 'confirmacion-preinscripcion' });
        }

    },
    computed:{
        ...mapGetters(["getSelectedCourse","getSelecteds"]),
        redsysUrl(){
            return window.env == 'production' ? 'https://sis.redsys.es/sis/realizarPago' : 'https://sis-t.redsys.es:25443/sis/realizarPago';
        }

    },
}
</script>
<style lang="scss" >
    .grid-payment-registration{
        display: flex;
        flex-direction: column;
        .column-payment{
                width: 100%;
        }
        @media (min-width:1024px) {
            flex-direction: row;
            max-width: 1000px;
            margin: auto;
            .column-payment{
                width: 50%;
            }

        }
    }
</style>
